<template lang="html">
  <section id="product-details" class="intro-product-details flex">
    <div class="text-content flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <div v-html="$t(`productos.${product}.details.intro.title`)"></div>
        <p v-html="$t(`productos.${product}.details.intro.text`)"></p>
        <a class="btn btn-dark -pink-full" target="_blank" :href="$t(`productos.${product}.details.intro.btn_redirect`)">
          {{ $t(`productos.${product}.details.intro.btn_text`) }}
        </a>
      </div>
    </div>
    <div id="slider">
      <ul>
        <li v-for="(product, index) in $t(`productos.${product}.details.intro.slider`)" :key="index" :class="{ on: index == currentIndex }">
          <!--
            Por debajo de 900 px se sirve la copia reducida y por encima el
            original, decidido antes de descargar nada. Antes se sustituia el src
            en `mounted()`, cuando la version grande ya se estaba descargando: en
            movil se acababan descargando las dos.
          -->
          <picture>
            <source media="(max-width: 900px)" :srcset="reducidaDe(product.img)">
            <img :src="product.img" :alt="product.alt" :title="product.alt">
          </picture>
          <button class="next" @click="currentIndex++" v-if="currentIndex < maxIndex">Siguiente</button>
          <button class="prev" @click="currentIndex--" v-if="currentIndex != 0">Anterior</button>
        </li>
      </ul>
    </div>
    <a href="#" v-scroll-to="'.section-links'" class="scrolldown"></a>
  </section>
</template>
  
<script lang="js">
export default {
  name: 'product',
  props: ['product'],
  mounted() {
    this.maxIndex = Object.keys(this.$t(`productos.${this.product}.details.intro.slider`)).at(-1);
  },
  methods: {
    /**
     * Copia reducida (900 px) de una imagen del carrusel, en
     * `static/img/responsive/`. Todas la tienen, asi que no hace falta
     * comprobarlo en tiempo de ejecucion.
     */
    reducidaDe(img) {
      if (!img || img.indexOf('/static/img/') !== 0) return null;
      return img.replace('/static/img/', '/static/img/responsive/');
    },
  },
  data() {
    return {
      maxIndex: 0,
      currentIndex: 0
    }
  },
  watch: {
      "$route.params.id"(){
        this.currentIndex = 0;
        this.maxIndex = Object.keys(this.$t(`productos.${this.product}.details.intro.slider`)).at(-1);
      }
    },
}
</script>
  
<style scoped>
.titleCatalogos {
  margin: 30px 0 20px 0;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
}

.menu-catalogo {
  flex-wrap: wrap;
}

.menu-catalogo li {
  margin-bottom: 10px;
  width: 100%;
}

@media screen and (max-width: 1024px) {
  .titleCatalogos {
    margin: 30px 0 5px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/view-parts/intros/product.vue